// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:58:27

export default {
  "id": "stickman-choosing-actions",
  "slug": "stickman-choosing-actions",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/bc1089b38ef24789944883a83e59b44d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/bc1089b38ef24789944883a83e59b44d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Stickman Choosing actions",
      "description": "The Stickman character was kidnapped by a creature and locked up in prison. Your task is to escape from prison. Use an item selection or action. What should I choose? Left or right? It's up to you.",
      "instructions": "Use a computer mouse or control with a touch!\nDifferent items will appear on the left and right. You need to choose the item that will allow you to continue your gaming adventure.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "escape",
        "jailbreak",
        "prison",
        "stick",
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "棍人选择行动",
      "description": "小人物被一只怪物绑架并被关押在监狱里。你的任务是逃离监狱。使用物品选择或行动。我应该选择哪个？左边还是右边？由你决定。",
      "instructions": "使用电脑鼠标或触摸控制！\n左右两侧将出现不同的物品。您需要选择能让您继续游戏冒险的物品。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "逃脱",
        "越狱",
        "监狱",
        "棍棒",
        "棍人"
      ]
    },
    "zh-TW": {
      "title": "棍人選擇動作",
      "description": "小木人角色被一種生物綁架並被關進了監獄。你的任務是從監獄中逃脫。使用物品選擇或行動。我該選擇哪一邊？左邊還是右邊？這取決於你。",
      "instructions": "使用電腦滑鼠或觸控操作！\n左右方將出現不同的物品。您需要選擇能讓您繼續遊戲冒險的物品。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "逃脫",
        "越獄",
        "監獄",
        "棒子",
        "棒人"
      ]
    },
    "zh-HK": {
      "title": "stickman 選擇動作",
      "description": "Stickman 這個角色被一種生物綁架並關進了監獄。你的任務是從監獄中逃脫。使用物品選擇或行動。我該選擇哪一邊？左邊還是右邊？這由你決定。",
      "instructions": "使用電腦滑鼠或觸控操作！\n左右兩邊將出現不同的物品。您需要選擇一個能讓您繼續遊戲冒險的物品。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "逃離",
        "脫獄",
        "監獄",
        "木棍",
        "木人"
      ]
    },
    "ja": {
      "title": "スティックマン アクション選択",
      "description": "スティックマンキャラクターは生物に誘拐され、刑務所に監禁された。あなたのタスクは刑務所から脱出することです。アイテムを選択したり、行動を起こしたりしてください。左か右か？あなた次第です。",
      "instructions": "コンピューターマウスまたはタッチで操作してください！\n左側と右側に異なるアイテムが表示されます。ゲームの冒険を続けるためのアイテムを選択してください。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "脱出",
        "脱獄",
        "刑務所",
        "棒",
        "スティックマン"
      ]
    },
    "ko": {
      "title": "스틱맨 행동 선택",
      "description": "stickman 캐릭터가 생물에 의해 구금되고 감옥에 갇혀 있습니다. 감옥에서 탈출하는 것이 당신의 임무입니다. 아이템 선택이나 행동을 사용하세요. 왼쪽이거나 오른쪽이요? 당신의 선택에 달려 있습니다.",
      "instructions": "컴퓨터 마우스나 탭 제어를 사용하세요!\n왼쪽과 오른쪽에 다양한 아이템이 나타납니다. 게임 모험을 계속할 수 있는 아이템을 선택해야 합니다.",
      "genres": [
        "모험"
      ],
      "tags": [
        "탈출",
        "감옥 풀기",
        "감옥",
        "막대",
        "스틱맨"
      ]
    },
    "fr": {
      "title": "Personnage en stickman choisissant des actions",
      "description": "Le personnage de Stickman a été enlevé par une créature et enfermé en prison. Votre tâche est de vous échapper de prison. Utilisez un choix d'objet ou une action. Que devrais-je choisir ? À gauche ou à droite ? C'est à vous de décider.",
      "instructions": "Utilisez une souris ou un contrôle tactile !\nDes objets différents apparaîtront à gauche et à droite. Vous devez choisir l'objet qui vous permettra de continuer votre aventure de jeu.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "échapper",
        "déverrouiller",
        "prison",
        "pique",
        "stickman"
      ]
    }
  }
};
